import isEmpty from 'lodash/isEmpty';
import React, { useContext, useEffect, useMemo, type JSX } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { FormBlock, StepProps } from '@/widgets/ServiceFormTemplate';

import { Grid, StepControlPanel } from '@/shared/ui';
import { AddressBlock, addressBlockPreview } from '@/shared/ui/AddressBlock';
import { UkrainianAddressSchema } from '@/shared/ui/AddressBlock/model';

import { IdConstants } from '@/components/Forms/constants';

import AuthContext from '@/contexts/Auth/AuthContext';

import { InsuredAddressSchema } from '../../model/types';

export const InsuredAddress: React.FC<StepProps> = ({ next, prev }) => {
  const { control, getValues, setValue } = useFormContext<InsuredAddressSchema>();
  const {
    addressesData: { REGISTRATION },
  } = useContext(AuthContext);

  const registrationFormAddress = useMemo<Partial<UkrainianAddressSchema>>(
    () =>
      ({
        country: REGISTRATION.country,
        region: REGISTRATION.region,
        district: REGISTRATION.district,
        settlement: REGISTRATION.settlement,
        street: REGISTRATION.street,
        house: REGISTRATION.house,
        building: REGISTRATION.building,
        apartment: REGISTRATION.apartment,
        zip_code: null,
      }) as Partial<UkrainianAddressSchema>,
    [REGISTRATION],
  );

  const isUkraine = registrationFormAddress.country?.id === IdConstants.UKRAINE;

  useEffect(() => {
    const formData = getValues();
    if (isEmpty(formData.insuredAddress) && Object.values(registrationFormAddress).some(Boolean) && isUkraine) {
      // @ts-ignore
      setValue('insuredAddress', registrationFormAddress);
    }
  }, [registrationFormAddress]);

  return (
    <>
      <FormBlock title="Адреса страхувальника">
        <Controller
          name="insuredAddress"
          control={control}
          render={({ field, formState: { errors } }): JSX.Element => (
            <AddressBlock
              address={field.value || (isUkraine ? registrationFormAddress : {})}
              onlyUkraine
              revalidate={!isEmpty(errors)}
              includeZipCode
              handleAddressChange={(newAddress): void => {
                field.onChange(newAddress);
              }}
            />
          )}
        />
      </FormBlock>

      <StepControlPanel next={next} prev={prev} />
    </>
  );
};

export const InsuredAddressPreview: React.FC = () => {
  const { getValues } = useFormContext<InsuredAddressSchema>();
  const { insuredAddress } = getValues();

  return (
    <Grid
      title="Адреса страхувальника"
      data={addressBlockPreview({
        address: insuredAddress,
        includeZipCode: true,
      })}
    />
  );
};
